import { ButtonTertiary } from "components/Atoms/Button";
import { PreviewPanelDetailRow } from "components/Atoms/details/PreviewPanelDetailRow";
import React, { useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { CompanyPreview } from "../Company/CompanyPreviewPanel";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader } from "../PreviewPanel";
interface BookkeepingPreviewPanelProps {
  bookkeepingId: number
}

const BookkeepingPreviewPanel = (props: BookkeepingPreviewPanelProps) => {
  const { bookkeepingId } = props

  const api = useApi(() => window.CoreApi.Bookkeeping.GetItem(bookkeepingId), ["bookkeeping", bookkeepingId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [bookkeepingId]);

  if (api.isLoading) {
    return <>
      <PreviewPanelHeader title={RESX.Bookkeeping.resxBookkeeping} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const bookkeeping = api.data.data;

  return <>
    <PreviewPanelHeader title={RESX.Bookkeeping.resxBookkeeping} />
    <PreviewPanelContent>
      <div className="flex-column gap-larger">
        <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Title}>
          {bookkeeping.name}
        </PreviewPanelDetailRow>

        <PreviewPanelDetailRow labelTop={RESX.Bookkeeping.Code}>
          {bookkeeping.code}
        </PreviewPanelDetailRow>

        <PreviewPanelDetailRow labelTop={RESX.Company.resxCompany}>
          <CompanyPreview
            companyId={bookkeeping.company.companyId}
            trigger={<>
              <a>{bookkeeping.company.name}</a>
              <div className="text-sublabel">
                {bookkeeping.company.address.join(", ")}
              </div>
            </>}
            fallbackIfNoPermission={<>
              <div>{bookkeeping.company.name}</div>
              <div className="text-sublabel">{bookkeeping.company.address.join(", ")}</div>
            </>}
          />
        </PreviewPanelDetailRow>

        <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Visible}>
          {bookkeeping.visible ? <i className="icon-true" /> : <i className="icon-false" />}
        </PreviewPanelDetailRow>

        <PreviewPanelDetailRow labelTop={RESX.Bookkeeping.ResetOnNewYear}>
          {bookkeeping.resetOnNewYear ? <i className="icon-true" /> : <i className="icon-false" />}
        </PreviewPanelDetailRow>
      </div>
    </PreviewPanelContent>
    <PreviewPanelFooter>
      {site.permissions.canConfigureSystemSettings && <ButtonTertiary href={routes.bookkeeping_Detail(bookkeepingId).absolute} label={RESX.Buttons.btnEdit} />}
    </PreviewPanelFooter>
  </>;
}

interface BookkeepingPreviewProps {
  bookkeepingId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const BookkeepingPreview = (props: BookkeepingPreviewProps) => {
  if (!site.permissions.canConfigureSystemSettings) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`bookkeeping-preview-${props.bookkeepingId}`}>
    <BookkeepingPreviewPanel
      bookkeepingId={props.bookkeepingId}
    />
  </PreviewPanel>;
}